// How long the calendar treats an account's NATIVELY-published post history as
// fresh (round 2 item 5). Pure, so the rule is asserted without jsdom.
//
// Native ("external") posts are never mirrored: they are fetched live from
// Zernio per account and cached client-side. History genuinely does not move,
// so 9 hours is right for it — but today does, and "I just posted natively, is
// it there?" is the case people actually hit. So when the calendar is SHOWING
// today, the same cache goes stale after 5 minutes.
//
// ⚠️ WHY THE VISIBLE RANGE AND NOT "THIS WEEK'S POSTS": the fetch cannot be
// date-scoped — listPosts({source:'external'}) ignores dateFrom (probe-verified)
// and returns the whole retained history — so there is no "current week" query
// to give its own lifetime. The brief's stated fallback is to key the short
// lifetime on whether the visible grid contains today, which is what this does.
//
// ⚠️ This changes how soon WE re-ask; it cannot beat Zernio's own native-sync
// lag (a post going live → Zernio returning it), and it does nothing for a post
// deleted on the platform: nothing is mirrored, so if Zernio still returns it,
// it renders. That is a vendor question, not a client cache.

export const EXTERNAL_HISTORY_STALE_MS = 9 * 60 * 60_000;
export const EXTERNAL_TODAY_STALE_MS = 5 * 60_000;

export function externalStaleMs(range: { from: string; to: string }, nowMs: number): number {
  const from = Date.parse(range.from);
  const to = Date.parse(range.to);
  if (!Number.isFinite(from) || !Number.isFinite(to)) return EXTERNAL_HISTORY_STALE_MS;
  return nowMs >= from && nowMs <= to ? EXTERNAL_TODAY_STALE_MS : EXTERNAL_HISTORY_STALE_MS;
}

/** The legend's plain statement of the cache, so it is said out loud. */
export function externalCacheNote(staleMs: number): string {
  return staleMs === EXTERNAL_TODAY_STALE_MS
    ? 'Natively published posts are re-checked every few minutes while this month is showing. Use Refresh to check now.'
    : 'Natively published posts for past months are kept for up to 9 hours. Use Refresh to check now.';
}
